/*
 * alix-lp-vitrin.js — Koleksiyon iniş sayfası "vitrin" düzeni (yalnız mobil).
 *
 * NEDEN: reklamdan gelen kullanıcı mobilde ilk ürünü görmek için 1,7 ekran
 * kaydırıyordu (ölçüm: ilk ürün bağlantısı 1.384 px, 375x812). Bu dosya
 * anlatım metnini SİLMEDEN ızgaranın altına indiriyor, kartlara sıra rozeti
 * ve "Sepete Ekle" ekliyor.
 *
 * SUNUCU HTML'İ DEĞİŞMİYOR — bu bilerek böyle: arama motoru sayfayı
 * JavaScript'siz okuduğunda metin hâlâ ızgaranın ÜSTÜNDE, yani mevcut SEO
 * düzeni korunuyor. Taşıma yalnız gerçek ziyaretçinin tarayıcısında oluyor.
 *
 * Betik bölümün hemen ardından, defer'siz çalışır: taşıma ilk boyamadan önce
 * bitsin ki kullanıcı metni görüp sonra kaybolmasın (layout kayması).
 */
(function () {
  var MOBIL = 767;
  if (window.innerWidth > MOBIL) return;

  /*
     Betik bölümün SONUNDA çalışıyor, yani ürün ızgarası henüz ayrıştırılmadı;
     taşımayı DOMContentLoaded'a bırakmak gerekiyor. Ama o ana kadar metin
     ekranda görünüp sonra kaybolursa göz yorucu bir kayma oluyor.

     Çözüm: kök öğeye şimdi bir sınıf ekliyoruz, CSS taşınacak parçaları o
     sınıf varken gizliyor; taşıma bitince sınıf kalkıyor. JavaScript kapalı
     bir tarayıcıda sınıf hiç eklenmediği için metin olduğu yerde ve görünür
     kalıyor — gizleme JS'e bağlı, içerik değil.
  */
  var KOK = document.documentElement;
  KOK.classList.add('alix-vitrin-hazirlaniyor');

  var ust = null;
  var grid = null;

  /* ---------------------------------------------------------------
     1) Ağır anlatım ızgaranın altına iner.
     Üstte kalanlar: eyebrow (.alp-kicker), H1 (.alp-h1) ve kategori
     çipleri (.alix-kmp-cip). Çipler kalıyor çünkü onlar gezinme,
     metin değil — kullanıcı "fondöten" diye geldiyse ilk hamlesi o.
     --------------------------------------------------------------- */
  function tasi() {
  var TASINACAK = [
    '.alp-hook',
    '.alp-lede',
    '.alp-chips',
    '.alp-btns',
    '.alp-glance',
    '#alix-kmp-deger',
    '.alix-kmp-baslik',
    '#alix-kmp-serit'
  ];

  var alt = document.createElement('div');
  alt.className = 'alix-vitrin-alt';
  grid.insertAdjacentElement('afterend', alt);

  TASINACAK.forEach(function (sec) {
    var el = ust.querySelector(sec);
    // Taşıma; kopyalama DEĞİL. Kopyalasak metin sayfada iki kez geçer.
    if (el) alt.appendChild(el);
  });

  // Hiçbir şey taşınmadıysa boş kutu bırakma.
  if (!alt.children.length) alt.remove();
  }

  /* ---------------------------------------------------------------
     2) Kartlar: sıra rozeti + Sepete Ekle.
     Izgarada her ürün için birden fazla kart düzeni basılıyor (masaüstü
     hover katmanı dahil) ve yalnız biri görünür; bu yüzden görünmeyen
     kartlara dokunulmuyor, yoksa aynı ürüne 3 buton eklenirdi.
     --------------------------------------------------------------- */
  function gorunur(el) {
    return !!(el.offsetParent || el.getClientRects().length);
  }


  /*
     Sıra rozeti yalnız "çok satan" kampanya koleksiyonlarında anlamlı: ızgara
     orada satış adedine göre sıralı. Bayrağı ayrı bir alan açmadan
     alix-kampanya.liquid'in zaten bastığı veri etiketinden okuyoruz.
  */
  function cokSatanMi() {
    var el = document.getElementById('alix-kampanya-veri');
    if (!el) return false;
    try {
      return JSON.parse(el.textContent).tip === 'cok-satan';
    } catch (e) {
      return false;
    }
  }

  /*
     Kartta "Sepete ekle" butonu ZATEN VAR — tema onu mobilde de basıyor
     (canlıda ölçüldü: 10 görünür kartın 9'unda çalışır durumda). Önce kendi
     butonumuzu ekliyorduk, mükerrer çıkıyordu; kaldırıldı. Burada yalnız sıra
     rozeti kalıyor, fiyat büyütmesini CSS yapıyor.
  */
  /*
     ÇAKIŞMA: etiket uygulaması (labels-and-badges) indirim/"Yeni" rozetlerini
     karta SONRADAN, görünürlüğe girince basıyor. Biz kartı işlerken sağ üst
     köşe boş görünüyor, rozet sonra gelince "Çok Satan #N" pilinin altına
     giriyor ve iki rozet üst üste biniyordu (mobilde canlıda görüldü).

     Çözüm: pilin varsayılan yerini bir kez kaydedip her turda o konumda
     çakışma var mı diye ölçüyoruz; varsa pili en alttaki çakışan rozetin
     altına indiriyoruz. Çakışma yoksa pil varsayılan yerinde kalıyor.

     Ölçüm varsayılan konuma göre yapıldığı için işlem tekrarlanabilir: aynı
     sonucu üretir, aynı değeri ikinci kez yazmaz. (Yazsaydı ızgaradaki
     gözlemci kendi kendini tetikleyip döngüye girerdi.)
  */
  var ARALIK = 6;

  function rozetiKonumla(kart, rozet) {
    var kartKutu = kart.getBoundingClientRect();
    var pil = rozet.getBoundingClientRect();
    if (!pil.height) return;

    if (!rozet.dataset.ustVarsayilan) {
      rozet.dataset.ustVarsayilan = String(Math.round(pil.top - kartKutu.top));
    }
    var varsayilanUst = kartKutu.top + parseInt(rozet.dataset.ustVarsayilan, 10);
    var varsayilanAlt = varsayilanUst + pil.height;

    var enAlt = 0;
    var adaylar = kart.querySelectorAll('.x-badge-container, [class*="x-badge"]');
    for (var i = 0; i < adaylar.length; i += 1) {
      var el = adaylar[i];
      if (el === rozet || el.contains(rozet) || rozet.contains(el)) continue;
      var b = el.getBoundingClientRect();
      if (!b.width || !b.height) continue;
      var yatay = b.left < pil.right && b.right > pil.left;
      var dikey = b.top < varsayilanAlt && b.bottom > varsayilanUst;
      if (yatay && dikey && b.bottom > enAlt) enAlt = b.bottom;
    }

    var yeni = enAlt ? Math.round(enAlt - kartKutu.top + ARALIK) + 'px' : '';
    if (rozet.style.top !== yeni) rozet.style.top = yeni;
  }

  function kartiZenginlestir(kart, sira, rozetVar) {
    if (kart.dataset.vitrin === '1') return;
    kart.dataset.vitrin = '1';

    if (rozetVar && sira <= 10 && !kart.querySelector('.alix-vitrin-rozet')) {
      var rozet = document.createElement('span');
      rozet.className = 'alix-vitrin-rozet';
      rozet.textContent = 'Çok Satan #' + sira;
      kart.insertAdjacentElement('afterbegin', rozet);
    }

    /*
       Kampanya etiketi ("1000TL Üzeri Powder Brush Hediye" gibi) görselin
       ALTINDA, başlığın üstünde iki satır kaplıyor ve fiyatı ilk ekranın
       dışına itiyordu. Marketing "fiyatlar ön planda" dediği için etiket
       fiyatın altına alınıyor — siliniyor değil, yer değiştiriyor.

       Görselin ÜSTÜNDEKİ rozetlere (indirim oranı, "Yeni") dokunulmuyor:
       onlar `top-*` / `bottom-*` konumlu katmanlarda duruyor ve zaten
       fiyatla yarışmıyor.
    */
    var fiyat = null;
    var fiyatlar = kart.querySelectorAll('.x-card-price');
    for (var f = 0; f < fiyatlar.length; f += 1) {
      if (fiyatlar[f].getBoundingClientRect().height > 0) {
        fiyat = fiyatlar[f];
        break;
      }
    }
    if (!fiyat) return;

    var etiketler = kart.querySelectorAll('.x-badge-container');
    for (var i = 0; i < etiketler.length; i += 1) {
      var et = etiketler[i];
      // Görselin üstündeki rozetler (indirim oranı, "Yeni") yerinde kalır.
      // Seçici açıkça bu dört kapsayıcıyı dışlıyor: `[class*="top-"]` gibi
      // geniş bir eşleşme Tailwind'in `top-2`, `lg:top-auto` gibi yardımcı
      // sınıflarına da takılıp etiketin kendisini eliyordu.
      if (
        et.closest(
          '.top-left-container, .top-right-container, .bottom-left-container, .bottom-right-container'
        )
      ) {
        continue;
      }
      if (et.getBoundingClientRect().height === 0) continue; // gizli kopya
      // Zaten fiyatın altındaysa tekrar taşıma.
      if (fiyat.compareDocumentPosition(et) & Node.DOCUMENT_POSITION_FOLLOWING) continue;
      fiyat.insertAdjacentElement('afterend', et);
    }
  }

  function kartlariGez() {
    var rozetVar = cokSatanMi();
    var gorulen = {};
    var sira = 0;
    var kartlar = grid.querySelectorAll('.card-product');
    for (var i = 0; i < kartlar.length; i += 1) {
      var kart = kartlar[i];
      if (!gorunur(kart)) continue;
      var link = kart.querySelector('a[href*="/products/"]');
      if (!link) continue;
      /*
         Aynı ürün için birden fazla GÖRÜNÜR kart basılabiliyor (tema iki
         düzeni birden bırakıyor). Buton hepsine gitmeli — yoksa kullanıcı
         aynı ürünü biri butonlu biri butonsuz iki kez görüyor. Sıra numarası
         ise üründen sayılmalı, karttan değil.
      */
      var anahtar = link.getAttribute('href').split('?')[0];
      if (!gorulen[anahtar]) {
        sira += 1;
        gorulen[anahtar] = sira;
      }
      kartiZenginlestir(kart, gorulen[anahtar], rozetVar);

      /* İşlenmiş kartlar da her turda yeniden ölçülüyor: etiket uygulaması
         rozetini sonradan bastığında pil kendiliğinden aşağı kaysın. */
      var mevcut = kart.querySelector('.alix-vitrin-rozet');
      if (mevcut) rozetiKonumla(kart, mevcut);
    }
  }

  function hazir() {
    ust = document.querySelector('[id^="shopify-section-"][id$="__lp_ust"]');
    grid = document.querySelector('[id^="shopify-section-"][id$="__product-grid"]');
    if (!ust || !grid) {
      KOK.classList.remove('alix-vitrin-hazirlaniyor');
      return;
    }
    ust.classList.add('alix-vitrin-ust');
    grid.classList.add('alix-vitrin-grid');

    tasi();
    KOK.classList.remove('alix-vitrin-hazirlaniyor');

    kartlariGez();

    /*
       Yeni kartları yakala. İki kaynak var:
       - filtre/sayfalama ızgarayı yeniden basıyor (childList),
       - temanın "daha fazla göster" düzeni kartları silmiyor, `alix-fazla-*`
         sınıfıyla gizleyip `alix-acik` ile açıyor (attributes).
       Kendi eklediğimiz data-vitrin de bir attribute değişimi olduğu için
       gözlemci kendini tetikliyor; gecikmeli tek tur bunu sönümlüyor ve
       kartiZenginlestir zaten tekrar işlemiyor.
    */
    var zamanlayici = null;
    var izle = new MutationObserver(function () {
      clearTimeout(zamanlayici);
      zamanlayici = setTimeout(kartlariGez, 120);
    });
    izle.observe(grid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hazir);
  } else {
    hazir();
  }
})();
